import { IconWrapper } from '../runtime';
export default IconWrapper('pixel-art', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 3.24976C1.75 2.42133 2.42157 1.74976 3.25 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498V3.24976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10 4H12V6H10V4Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10 8H12V10H10V8Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 10H10V12H8V10Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6 8H8V10H6V8Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4 10H6V12H4V10Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});